import { IWindowFeatures } from '../interfaces/window/IWindowFeatures';

const windowFeatureIsEnabled = (feature: keyof IWindowFeatures): boolean => {
  const windowFeatures = (window.FEATURES || {}) as IWindowFeatures;
  const featureSetting = windowFeatures[feature];
  return featureSetting === true;
};

export { windowFeatureIsEnabled };
